document.addEventListener('click', function (e) {
  const link = e.target.closest('a[href="#"]');
  if (!link) return;

  // DESKTOP: muchos temas (incl. Motion) usan <details> para el dropdown
  const details = link.closest('details');
  if (details) {
    e.preventDefault();
    details.toggleAttribute('open'); // abre/cierra el submenú
    return;
  }

  // MÓVIL (drawer): busca el toggle del submenú junto al enlace padre
  const item = link.closest('li, .menu-drawer__menu-item, .drawer__menu-item');
  const toggle =
    item &&
    (item.querySelector('button[aria-controls], button[aria-expanded], .menu-drawer__open-button, .icon-caret, [data-toggle-submenu]'));

  if (toggle) {
    e.preventDefault();
    toggle.click(); // dispara el submenú del drawer
    return;
  }

  // Fallback: evita salto a # aunque no encontremos toggle
  e.preventDefault();
});
